import AvailableJobsHeader from "../components/AvailableJobsHeader";
import Joblist from "../components/Joblist";

export default function Home() {
  return (
    <>
      <AvailableJobsHeader />
      <Joblist />
    </>
  );
}
